import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(d, e) {
  return n(), l("svg", t, e[0] || (e[0] = [
    o("path", {
      fill: "#1E0046",
      "fill-rule": "evenodd",
      d: "M4.444 4C2.586 4 1 5.449 1 7.333v2.334q0 .056.006.11A1 1 0 0 0 2 10.889h11a1 1 0 1 0 0-1.999H3V7.333C3 6.64 3.602 6 4.444 6h15.112C20.398 6 21 6.64 21 7.334v2.333a1 1 0 0 0 2 0V7.334C23 5.449 21.414 4 19.556 4H4.444M3 13.59a1 1 0 1 0-2 0v3.077C1 18.55 2.586 20 4.444 20h15.112C21.414 20 23 18.551 23 16.667V13.59a1 1 0 1 0-2 0v3.076C21 17.36 20.398 18 19.556 18H4.444C3.602 18 3 17.36 3 16.667zm13.367-2.735c-.604.96-1.367 2.46-1.367 3.27 0 1.173.941 1.875 2 1.875.847 0 2-.488 2-1.875 0-.885-.814-2.32-1.404-3.243-.31-.486-.921-.516-1.229-.027",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a = { render: r };
export {
  a as default,
  r as render
};
//# sourceMappingURL=ic_fuel_card-Byu4OSDa.js.map
